import {formatPath} from './utils';
import {AuthRouteNames} from './route-names';

import LoadingScreen from '../views/LoadingScreen.vue';
import AdminLogin from '../views/auth/Login.vue';
import ForgotPassword from '../views/auth/ForgotPassword.vue';
import Register from '../views/auth/Register.vue';
import AiSetup from '../views/auth/AiSetup.vue';
import LoginCallbackView from '../views/auth/LoginCallbackView.vue';
import { RouteRecordRaw } from 'vue-router';

export const authRouter: RouteRecordRaw[] = [
  {
    path: '',
    component: LoadingScreen,
  },
  {
    path: formatPath(AuthRouteNames.AdminLogin),
    name: AuthRouteNames.AdminLogin,
    component: AdminLogin,
  },
  {
    path: formatPath(AuthRouteNames.ResetPassword),
    name: AuthRouteNames.ResetPassword,
    component: ForgotPassword,
  },
  {
    path: formatPath(AuthRouteNames.Register),
    name: AuthRouteNames.Register,
    component: Register,
  },
  {
    path: formatPath(AuthRouteNames.AiSetup),
    name: AuthRouteNames.AiSetup,
    component: AiSetup,
  },
  {
    path: '/auth/callback/:provider',
    name: AuthRouteNames.LoginCallback,
    component: LoginCallbackView,
  },
];
